module.exports = __webpack_public_path__ + "img/homeTag-icon-2.d9f81ea6.svg";